// Schreiben-Assistent Etappe 4: frühere Fassungen einer Brief-Vorlage (Trigger dokument_vorlagen_version_sichern
// legt bei jeder Änderung den alten Stand ab). „Laden“ füllt den Editor – erst Speichern macht die Fassung aktuell.
import { supabase } from '../supabase/client';
import { vorlageZuBrief } from '../dokumente/briefDaten';
import type { VorlagenExtras } from './favoriten';

export interface VorlagenVersion { id: string; version: number; gueltigBis: string; ersetztVon: string | null; daten: Record<string, unknown> }

const EXTRA_FELDER = ['zielgruppe', 'immer_post', 'begleittext', 'briefkopf_id', 'schriftform', 'einschreiben', 'wiedervorlage_tage', 'vorgangsart_id'] as const;

/** Alter Stand → Felder des Editors. Zusatzfelder nur, soweit es sie in der Fassung schon gab. */
export function versionZuEditor(d: Record<string, unknown>): { name: string; kategorie: string; beschreibung: string; betreff: string; text: string; extras: Partial<VorlagenExtras> } {
  const b = vorlageZuBrief(String(d.html_template ?? ''), {});
  const extras: Record<string, unknown> = {};
  for (const f of EXTRA_FELDER) if (f in d) extras[f] = f === 'begleittext' ? (d[f] ?? '') : d[f];
  return { name: String(d.name ?? ''), kategorie: String(d.kategorie ?? 'anschreiben'), beschreibung: String(d.beschreibung ?? ''), betreff: b.betreff, text: b.text, extras: extras as Partial<VorlagenExtras> };
}

/** Neueste zuerst. null = Tabelle fehlt noch (Migration Etappe 4). */
export async function ladeVersionen(vorlageId: string): Promise<VorlagenVersion[] | null> {
  const { data, error } = await supabase.from('dokument_vorlagen_versionen').select('id, version, gueltig_bis, ersetzt_von, daten')
    .eq('vorlage_id', vorlageId).order('version', { ascending: false }).limit(50);
  if (error) return null;
  const zeilen = (data ?? []) as { id: string; version: number; gueltig_bis: string; ersetzt_von: string | null; daten: Record<string, unknown> }[];
  const ids = [...new Set(zeilen.map((z) => z.ersetzt_von).filter((x): x is string => !!x))];
  const namen = new Map<string, string>();
  if (ids.length) {
    const { data: p } = await supabase.from('profiles').select('id, full_name, email').in('id', ids);
    for (const x of (p ?? []) as { id: string; full_name: string | null; email: string | null }[]) namen.set(x.id, x.full_name?.trim() || x.email || '');
  }
  return zeilen.map((z) => ({ id: z.id, version: z.version, gueltigBis: z.gueltig_bis, ersetztVon: z.ersetzt_von ? namen.get(z.ersetzt_von) || null : null, daten: z.daten }));
}
